import { Calendar, ImagePlus, Pencil, RotateCcw, Shapes, Trash2 } from "lucide-react";
import React, { useContext } from "react";
import { ManufacturerCategory, useGetV4ManufacturerByRouteManufacturerIdAccountQuery } from "randmar-api-client";
import { Button, Separator } from "randmarcomps";
import ManufacturerContext from "../../contexts/ManufacturerContext";
import DeleteCategoryWrapper from "./DeleteCategoryWrapper";
import EditCategoryImageWrapper from "./EditCategoryImageWrapper";
import EditCategoryWrapper from "./EditCategoryWrapper";

interface IProps {
  category: ManufacturerCategory;
}

const intRegEx = new RegExp("^([0-9]+)?$|^$");

const CategoryActions: React.FC<IProps> = ({ category }) => {
  const { applicationId } = useContext(ManufacturerContext);
  const { data: manufacturer } = useGetV4ManufacturerByRouteManufacturerIdAccountQuery({ routeManufacturerId: applicationId });

  return (
    <div className="w-full max-w-[280px] p-2">
      <p className="px-2 pb-2 text-xs font-semibold uppercase tracking-wide text-muted-foreground">
        Edit {category.CategoryName}
      </p>

      <EditCategoryWrapper
        informationName="CategoryName"
        informationCurrentValue={category.CategoryName ?? undefined}
        validateFonction={(s: string) => s !== ""}
        label={"Category Name"}
        categoryCode={category.CategoryCode || ""}
        isFloatInput={false}
      >
        <Button variant="ghost" className="h-10 w-full justify-start gap-2 rounded-xl px-3 text-[15px] font-medium">
          <Pencil className="h-4 w-4" aria-hidden="true" />
          Name
        </Button>
      </EditCategoryWrapper>
      <EditCategoryWrapper
        informationName="Niche"
        informationCurrentValue={category.Niche ?? undefined}
        validateFonction={(s: string) => s !== ""}
        label={"Category Niche"}
        categoryCode={category.CategoryCode || ""}
        isFloatInput={false}
      >
        <Button variant="ghost" className="h-10 w-full justify-start gap-2 rounded-xl px-3 text-[15px] font-medium">
          <Shapes className="h-4 w-4" aria-hidden="true" />
          Niche
        </Button>
      </EditCategoryWrapper>
      <EditCategoryWrapper
        informationName="WeeksOfStocking"
        informationCurrentValue={String(category.WeeksOfStocking ?? manufacturer?.DefaultWeeksOfStocking ?? "")}
        validateFonction={intRegEx.test.bind(intRegEx)}
        label={"Weeks Of Stocking"}
        categoryCode={category.CategoryCode || ""}
        isFloatInput={false}
      >
        <Button variant="ghost" className="h-10 w-full justify-start gap-2 rounded-xl px-3 text-[15px] font-medium">
          <Calendar className="h-4 w-4" aria-hidden="true" />
          Weeks of stocking
        </Button>
      </EditCategoryWrapper>

      <Separator className="my-2" />

      <p className="px-2 pb-2 text-xs font-semibold uppercase tracking-wide text-muted-foreground">Utilities</p>
      {
        category.Products?.length === 0 &&
        <DeleteCategoryWrapper
          category={category}
          buttonTitle="Reset to Default Settings"
          text="These are your default settings"
        >
          <Button variant="ghost" className="h-10 w-full justify-start gap-2 rounded-xl px-3 text-[15px] font-medium">
            <RotateCcw className="h-4 w-4" aria-hidden="true" />
            Reset to default
          </Button>
        </DeleteCategoryWrapper>
      }

      <EditCategoryImageWrapper  categoryCode={category.CategoryCode || ""}>
        <Button variant="ghost" className="h-10 w-full justify-start gap-2 rounded-xl px-3 text-[15px] font-medium">
          <ImagePlus className="h-4 w-4" aria-hidden="true" />
          Upload category image
        </Button>
      </EditCategoryImageWrapper>
      {
        (!category.Products || category.Products.length <= 0) &&
        <DeleteCategoryWrapper
          category={category}
          buttonTitle="Delete Category"
          disabled={!!category.Products && category.Products.length > 0}
          text="Delete forever?"
        >
          <Button variant="ghost" className="h-10 w-full justify-start gap-2 rounded-xl px-3 text-[15px] font-medium text-destructive">
            <Trash2 className="h-4 w-4" aria-hidden="true" />
            Delete category
          </Button>
        </DeleteCategoryWrapper>
      }
    </div>
  )
};

export default CategoryActions;
